export default {"src":"/_next/static/media/users-group-2.4356796a.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};